
import { defineComponent } from 'vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters: mapGettersGenesys } = createNamespacedHelpers('genesys')
export default defineComponent({
  name: 'ChatBotContactUsButton',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGettersGenesys(['chatBotConfig']),
  },
})
